import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageQuery } from './state/page/page.query';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  loading$ = this._pageQuery.loading$;

  constructor(private _pageQuery: PageQuery) {
  }
}
